import { render, staticRenderFns } from "./ButtonsSwitcher.vue?vue&type=template&id=09eb58ec&scoped=true"
import script from "./ButtonsSwitcher.vue?vue&type=script&lang=js"
export * from "./ButtonsSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ButtonsSwitcher.vue?vue&type=style&index=0&id=09eb58ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb58ec",
  null
  
)

export default component.exports